import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Button, Typography, OutlinedInput } from "@mui/material";
import { ContactModalProps } from "../../../interfaces/props/SaudeOnline/ContactModalProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  sxButton,
  sxError,
  sxInput,
  sxLabel,
  sxModal,
  sxOutlinedButton,
} from "./sxProps";
import { useFormik } from "formik";
import "./styles.css";
import { ScheduleContactsValidation } from "../../../interfaces/validation/ScheduleContactsValidation";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { cellphoneMask } from "../../../utils/PhoneRegex";

function ContactModal(props: ContactModalProps) {
  const { cel, email, tel, open, handleClose, handleSave } = props;

  const formik = useFormik({
    initialValues: { tel, cel, email },
    validationSchema: ScheduleContactsValidation,
    onSubmit: (values) => {
      handleSave(values.tel, values.cel, values.email);
    },
    validateOnChange: false
  });

  const { fontSizeStyleAccessibility } = useAccessibility();

  useEffect(() => {
    formik.setValues({ tel, cel: cellphoneMask(cel), email });
  }, [open])

  const handleCloseInternal = () => {
    formik.resetForm();
    handleClose();
  };

  return (
    <div className="confirmation-modal-holder">
      <Modal
        open={props.open}
        onClose={handleCloseInternal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={sxModal}>
          <form onSubmit={formik.handleSubmit}>
            <div className="confirmation-modal-header">
              <h1
                className="confirmation-modal-header-title"
                style={fontSizeStyleAccessibility}
              >
                Atualizar dados do contato
              </h1>
              <button
                className="confirmation-modal-header-close"
                onClick={handleCloseInternal}
                aria-label="fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="confirmation-modal-info">
              <Typography sx={sxLabel} style={fontSizeStyleAccessibility}>
                Telefone
              </Typography>
              <label htmlFor="tel-input" aria-label="telefone" />
              <OutlinedInput
                fullWidth
                id="tel-input"
                type={"tel"}
                value={formik.values.tel}
                onChange={(e) => formik.setFieldValue('tel', cellphoneMask(e.target.value))}
                name="tel"
                error={!!formik.errors.tel}
                maxRows={1}
                inputProps={{ maxLength: 15 }}
                sx={sxInput}
                style={fontSizeStyleAccessibility}
              />
              {formik.errors.tel && (
                <Typography
                  sx={sxError}
                  style={fontSizeStyleAccessibility}
                  tabIndex={0}
                >
                  {formik.errors.tel}
                </Typography>
              )}
            </div>
            <div className="confirmation-modal-info">
              <Typography sx={sxLabel} style={fontSizeStyleAccessibility}>
                Celular
              </Typography>
              <label htmlFor="cel-input" aria-label="celular" />
              <OutlinedInput
                fullWidth
                id="cel-input"
                type={"tel"}
                value={formik.values.cel}
                onChange={(e) => formik.setFieldValue('cel', cellphoneMask(e.target.value))}
                name="cel"
                error={!!formik.errors.cel}
                maxRows={1}
                inputProps={{ maxLength: 15 }}
                sx={sxInput}
                style={fontSizeStyleAccessibility}
              />
              {formik.errors.cel && (
                <Typography
                  style={fontSizeStyleAccessibility}
                  tabIndex={0}
                  sx={sxError}
                >
                  {formik.errors.cel}
                </Typography>
              )}
            </div>
            <div className="confirmation-modal-info">
              <Typography sx={sxLabel} style={fontSizeStyleAccessibility}>
                E-mail
              </Typography>
              <label htmlFor="email-input" aria-label="email" />
              <OutlinedInput
                fullWidth
                type={"email"}
                id="email-input"
                value={formik.values.email}
                onChange={formik.handleChange}
                name="email"
                error={!!formik.errors.email}
                maxRows={1}
                inputProps={{ maxLength: 100 }}
                sx={sxInput}
                style={fontSizeStyleAccessibility}
              />
              {formik.errors.email && (
                <Typography
                  style={fontSizeStyleAccessibility}
                  tabIndex={0}
                  sx={sxError}
                >
                  {formik.errors.email}
                </Typography>
              )}
            </div>
            <div className="confirmation-modal-buttons">
              <div className="confirmation-modal-button">
                <Button
                  variant="outlined"
                  onClick={handleCloseInternal}
                  sx={sxOutlinedButton}
                  disabled={false}
                  style={fontSizeStyleAccessibility}
                  fullWidth
                >
                  <span style={{ color: "#00995D" }}>Cancelar</span>
                </Button>
              </div>
              <div className="confirmation-modal-button">
                <Button
                  variant="contained"
                  type="submit"
                  sx={sxButton}
                  disabled={false}
                  style={fontSizeStyleAccessibility}
                  fullWidth
                >
                  Salvar
                </Button>
              </div>
            </div>
          </form>
        </Box>
      </Modal>
    </div>
  );
}

export default ContactModal;
